module.exports = __webpack_public_path__ + "static/media/automacao_soldagem.a70687e6.png";